@if (finding) {
  <span
    class="field-warning"
    [class.field-warning--above-end]="placement === 'above-end'"
    role="img"
    tabindex="0"
    [attr.data-tooltip]="finding.reasonKey | translate: finding.reasonParams"
    [attr.aria-label]="
      (finding.labelKey | translate) +
      ': ' +
      (finding.reasonKey | translate: finding.reasonParams)
    "
    (keydown.escape)="closeHover($event)"
    ><mat-icon class="field-warning__icon">warning</mat-icon></span
  >
}
